import { render } from "./Workadd.vue?vue&type=template&id=0371bdde&scoped=true"
import script from "./Workadd.vue?vue&type=script&lang=js"
export * from "./Workadd.vue?vue&type=script&lang=js"

import "./Workadd.vue?vue&type=style&index=0&id=0371bdde&lang=scss&scoped=true"

import exportComponent from "/data/jenkins/workspace/staging-package-front-service/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0371bdde"]])

export default __exports__